import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

import { api } from '../lib/api-client';
import { syncFireAndForget } from '../lib/sync';

export type RitualPeriod = 'day' | 'week';
export type RitualIntensity = 'soft' | 'challenging' | 'push';

interface RitualState {
  count: number | null;
  period: RitualPeriod | null;
  /** Preset chip that seeded the current values, or null if the user hand-picked. */
  intensity: RitualIntensity | null;
  /** True once the user has confirmed a cadence — false after a skip. */
  isConfigured: boolean;
  setCadence: (input: {
    count: number;
    period: RitualPeriod;
    intensity: RitualIntensity | null;
  }) => void;
  hydrate: (input: {
    count: number | null;
    period: RitualPeriod | null;
    intensity: RitualIntensity | null;
    isConfigured: boolean;
  }) => void;
  reset: () => void;
}

const initial = {
  count: null,
  period: null,
  intensity: null,
  isConfigured: false,
};

export const useRitualStore = create<RitualState>()(
  persist(
    (set) => ({
      ...initial,
      setCadence: ({ count, period, intensity }) => {
        set({ count, period, intensity, isConfigured: true });
        syncFireAndForget(() =>
          api.me.updateRitual({ count, period, intensity, isConfigured: true }),
        );
      },
      hydrate: (input) => set({ ...input }),
      reset: () => set({ ...initial }),
    }),
    {
      name: 'llura.ritual',
      storage: createJSONStorage(() => localStorage),
      version: 1,
    },
  ),
);
